<template>
  <a-form-item :label="$t('scope.text_62')">
    <vxe-grid :columns="columns" :data="list" />
  </a-form-item>
</template>

<script>
import shareStorageMixin from '../mixins/shareStorageMixin'
import { getNameDescriptionTableColumn } from '@/utils/common/tableColumn'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'GuideShareStorageNFCList',
  mixins: [WindowsMixin, shareStorageMixin],
  props: {
    list: {
      type: Array,
    },
    manager: {
      type: Object,
    },
    refresh: {
      type: Function,
    },
  },
  computed: {
    columns () {
      return [
        getNameDescriptionTableColumn({
          title: this.$t('scope.text_21'),
          showDesc: false,
        }),
        {
          field: 'storage_conf.nfs_host',
          title: 'NFS Host',
        },
        {
          field: 'storage_conf.nfs_shared_dir',
          title: 'NFS Shared Dir',
        },
        {
          field: 'host',
          title: this.$t('scope.text_60'),
          width: 300,
          slots: {
            default: ({ row }) => {
              if (row.hosts && row.hosts.length > 0) {
                return row.hosts.map((item, index) => {
                  return <span> {index ? '|' : null} {item.name} </span>
                })
              }
            },
          },
        },
        {
          field: 'delete',
          title: this.$t('scope.text_61'),
          slots: {
            default: ({ row }) => {
              return [
                <a onClick={() => this.handleDeleteRow(row)}>{this.$t('table.action.delete')}</a>,
                <a class="ml-2" onClick={() => this.handleBindHosts(row)}>{this.$t('scope.text_118')}</a>,
              ]
            },
          },
        },
      ]
    },
  },
}
</script>
